import { useLoadScript } from '@react-google-maps/api'
import env, { envStore } from '@shared/env'
import { useTranslation } from 'react-i18next'

export default function useLoadGoogleMap() {
  const { i18n } = useTranslation()

  return useLoadScript({
    ...scriptOptions,
    language: i18n.language || 'zh-TW',
    nonce: envStore.cspNonce,
  })
}

const scriptOptions = {
  googleMapsApiKey: env.googleMapsApiKey,
  libraries: ['places', 'visualization'] as (
    | 'places'
    | 'visualization'
    | 'geometry'
  )[],
  region: 'zh-TW',
}
